<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-input v-model="args['order.no']" clearable placeholder="placeholder.pleaseEnterOrderNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="args['customer.no']" clearable placeholder="placeholder.pleaseEnterCustomerNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="args['customer.name']" clearable placeholder="placeholder.pleaseEnterCustomerName" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table
        ref="table"
        :column-config="{resizable: true}"
        :data="data"
        :export-config="{}"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe
        @cell-click="({row})=>showDetails(row)">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
        <vxe-column :title="type ==='refundable'? 'business.label.returnOperator': 'business.label.operator'" field="order.operator"/>
        <vxe-column field="customer.no" title="business.label.customerNo"/>
        <vxe-column field="customer.name" title="business.label.customerName" width="300"/>
        <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
        <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
        <vxe-column :title="type ==='refundable'? 'business.label.returnMethod': 'business.label.pickupMode'" field="pickupMode.name"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column field="order.notes" title="business.label.notes"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.issue" icon="vxe-icon-send" status="primary" @click.stop="issue(row)"/>
            <vxe-button v-if="changeToDispatch" content="button.changeToDispatch" icon="vxe-icon-indicator" status="danger" @click.stop="restore(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import { mixin, mixinDevice } from '@/utils/mixin'

export default {
  name: 'IssueOrder',
  mixins: [mixin, mixinDevice],
  data() {
    return {
      loading: false,
      data: [],
      changeToDispatch: this.type === 'appointed' || this.type === 'oneStep',
      args: {
        'order.no': '',
        'customer.no': '',
        'customer.name': ''
      },
      typeOptions: {
        appointed: {
          refundable: false,
          orderStatus: 11,
          appointed: true
        },
        oneStep: {
          refundable: false,
          orderStatus: 11,
          appointed: false,
          oneStep: true
        },
        refundable: {
          refundable: true,
          orderStatus: 11
        },
        shortable: {
          refundable: false,
          orderStatus: 11,
          shortable: true
        },
        suspended: {
          refundable: false,
          orderStatus: 23
        }
      },
      page: 1,
      size: 10,
      contentSize: 0
    }
  },
  activated() {
    this.refresh()
  },
  props: {
    type: {
      type: String
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = {
        ...this.typeOptions[this.type],
        ...this.args
      }
      findAll('dispatchOrderListFactory', args, this.page, this.size).then((res) => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
          if (this.data.length > 0) {
            this.$refs.table.setRadioRow(this.data[0])
            this.$refs.table.setCurrentRow(this.data[0])
            this.showDetails(this.data[0])
          } else {
            this.clearDetails()
          }
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.args = {
        'order.no': '',
        'customer.no': '',
        'customer.name': ''
      }
      this.refresh()
    },
    issue(row) {
      this.$emit('issue', row)
    },
    restore(row) {
      this.$emit('restore', row)
    },
    showDetails(row) {
      this.$emit('showDetails', row)
    },
    clearDetails() {
      this.$emit('clearDetails')
    }
  }
}
</script>